<template>

  <v-container pa-0>

    <v-content class="pa-0 ma-0" >
      <section class="ma-0 pa-0">
        <v-parallax v-bind:src="require('@/assets/parallax-livebruhs.png')" height="600" >
          <v-layout
            column
            align-center
            justify-center
            class="accent--text"
          >
            <img src="@/assets/zzlogo.png" alt="Vuetify.js" height="200">
            <h1 class="white--text mb-2 display-1 text-xs-center" style="text-shadow: 1px 1px grey;">Zeta Zeta Chapter</h1>
            <div class="subheading mb-3 text-xs-center" style="text-shadow: 1px 1px grey;">University of South Carolina</div>
            <div class="white--text subheading mb-3 text-xs-center">The online members-only portal for networking, socializing and general communication.</div>
            <v-btn v-if="member"
              class="primary mt-5"
              dark
              large
              to="/timeline"
            >
              See What's Going On
            </v-btn>
            <v-btn v-else-if="user"
              class="primary mt-5"
              dark
              large
              to="/profile"
            >
              Get Verified
            </v-btn>   
            <v-btn v-else
              class="primary mt-5"
              dark
              large
              to="/signin"
            >
              Sign In
            </v-btn>                       
          </v-layout>
        </v-parallax>
      </section>

      <section>
        <v-layout
          column
          wrap
          class="my-5"
          align-center
        >
          <v-flex xs12 sm4 class="my-3">
            <div class="text-xs-center">
              <h2 class="headline">The best way to reach the bros!</h2>
              <span class="subheading">
                z z q u e s . m y q u e p s i p h i . c o m
              </span>
            </div>
          </v-flex>
          <v-flex xs12>
            <v-container grid-list-xl>
              <v-layout row wrap align-center>
                <v-flex xs12 md4>
                  <v-card class="elevation-0 transparent">
                    <v-card-text class="text-xs-center">
                      <v-icon x-large class="primary--text">verified_user</v-icon>
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline text-xs-center">Verified Members-Only</div>
                    </v-card-title>
                    <v-card-text>
                      Security is #1. This portal has been designed to allow access to only verified members. Any one who logs on for the first time and 
                      "claims to be" a particular member must be "vouched for" by at least 2 registered members before being allowed to enter.
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 md4>
                  <v-card class="elevation-0 transparent">
                    <v-card-text class="text-xs-center">
                      <v-icon x-large class="primary--text">forum</v-icon>
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center">

                      <v-layout row wrap>
                         <v-flex xs12 class="text-xs-center">
                            <div class="headline">Real-Time Communication</div>
                         </v-flex>                        
                        <v-flex xs12 class="text-xs-center pt-0">
                        <v-icon small class="primary--text text--lighten-3 pl-3 pr-3 pt-0">language</v-icon>
                        <v-icon small class="primary--text text--lighten-3 pl-3 pr-3 pt-0">where_to_vote</v-icon>
                        <v-icon small class="primary--text text--lighten-3 pl-3 pr-3 pt-0">add_a_photo</v-icon>
                        <v-icon small class="primary--text text--lighten-3 pl-3 pr-3 pt-0">today</v-icon>
                        <v-icon small class="primary--text text--lighten-3 pl-3 pr-3 pt-0">work</v-icon>
                        
                        </v-flex>
                      </v-layout>                      
                    </v-card-title>
                    <v-card-text>
                      The Chapter Member Database is pre-populate. As members register, it is simple to remain in constant contact. Discuss
                      fundraisers, job opportunities, business ventures and more.
                      Members can even use the portal to Check In with their latest location and post pictures.
                      <br/>

                    </v-card-text>
                  </v-card>
                </v-flex>

                <v-flex xs12 md4>
                  <v-card class="elevation-0 transparent">
                    <v-card-text class="text-xs-center">
                      <v-icon x-large class="primary--text">far fa-money-bill-alt</v-icon>
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline text-xs-center">Track Fundraising</div>
                    </v-card-title>
                    <v-card-text class="font-weight-bold  subheading text-xs-center">
                      <v-icon class="primary--text text--lighten-3 pl-3 pr-3 pt-2">school</v-icon> Endowment<br/>
                      <v-icon class="primary--text text--lighten-3 pl-3 pr-3 pt-2">restaurant</v-icon> Homecoming Tailgate

                                        
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </section>

      <section>
        <v-parallax v-bind:src="require('@/assets/parallax-oldschool.png')" height="380">
          <v-layout column align-center justify-center>
            <div class="headline white--text mb-3 text-xs-center">Chapter networking has never been easier</div>
            <em>Get connected with the chapter today</em>
            <v-btn v-if="member"
              class="primary mt-5"
              dark
              large
              to="/timeline"
            >
              See What's Going On
            </v-btn>
            <v-btn v-else-if="user"
              class="primary mt-5"
              dark
              large
              to="/profile"
            >
              Get Verified
            </v-btn>   
            <v-btn v-else
              class="primary mt-5"
              dark
              large
              to="/signin"
            >
              Sign In
            </v-btn>   
          </v-layout>
        </v-parallax>
      </section>

      <section>
        <v-container grid-list-xl>
          <v-layout row wrap justify-center class="my-5">
            <v-flex xs12 sm4>
              <v-card class="elevation-0 transparent">
                <v-card-title primary-title class="layout justify-center">
                  <div class="headline">Chapter History</div>
                </v-card-title>
                <v-card-text>
                  <p>Through the efforts of twelve (12) men, who felt the need for a lifelong challenge of brotherhood and friendship, Omega was sought. With the aid of a brother from Epsilon Epsilon Chapter (Kent Glover), these twelve men contacted Brother Charlie T. Brooks, Sr., of Omicron Phi Chapter.</p>
                  <p>n the early fall of 1972, the wheels were set in motion; papers were filed and connections were made through IFC (Intrafraternity Council). These are the twelve men whose names were signed to meet the challenges of Omega:</p>
                  <v-layout row wrap>
                    <v-flex xs-6>
                      <ul>
                      <li>Eugene Glover</li>
                      <li>Wayne J. Glover </li>
                      <li>Shederick Harrison, Jr.</li>
                      <li>Kenneth Heyward </li>
                      <li>Arthur O. Howard</li>
                      <li>Lawrence Keitt</li>
                      </ul>
                    </v-flex>
                    <v-flex xs-6>
                      <ul>
                      <li>Paul S. McLeod</li>
                      <li>Carl B. Miller </li>
                      <li>Milton Reid </li>
                      <li>Lee M. Tyler </li>
                      <li>Harvey Weens, Jr. </li>
                      <li>McArthur (Darryl) Brown</li>
                      </ul>
                    </v-flex>                    
                  </v-layout>
                  <p>On February 5, 1973, the first essential step was made. A total of 35 men were inducted into the Lampadoes Club of Omega Psi Phi at the University of South Carolina. These men came from all parts of the University. Omega captured the eye of some of the greatest men existing on campus.</p>
                  <p>After eleven weeks of evaluation of lifelong brotherhood, friendship, manhood, perseverance, scholarship, and uplift, Omega made a firm stand on April 14, 1973. On this day, by way of the Omicron Phi chapter, a total of 34 men crossed those "Burning Sands" into the land of Omega.</p>
                  <p><em>*Due to a near fatal car accident, number 12, Anthony Jamison crossed the sands in the fall of 1973.</em></p>
                </v-card-text>
              </v-card>
            </v-flex>
           
          </v-layout>
        </v-container>
      </section>

      <v-footer class="accent darken-2">
        <v-layout row wrap align-center>
          <v-flex xs12>
            <!--
            <div class="white--text ml-3">
              Made with
              <v-icon class="red--text">favorite</v-icon>
              by <a class="white--text" href="https://vuetifyjs.com" target="_blank">Vuetify</a>
              and <a class="white--text" href="https://github.com/vwxyzjn">Costa Huang</a>
            </div>
            -->
          </v-flex>
        </v-layout>
      </v-footer>
    </v-content>

  </v-container>
</template>

<script>
import firebase from 'firebase'
import moment from 'moment'
const DATEFORMAT = "ddd, MMM D h:mmA"

  export default {
      data(){
          return{
            test:''             
          }

      },
    computed: {
      user () {
        return this.$store.getters.user
      },

      member () {
          return this.$store.getters.member

      }
    },
    watch:{

    },
    methods:{
 

    }
  }
</script>

<style>

</style>